import _ from 'lodash'
import { TableCell, TableRow } from '@/components/ui/table'
import { Skeleton } from '@/components/ui/skeleton'

export function TransactionSkeletonRows() {
	return (
		<>
			{_.times(8, (index) => (
				<TableRow key={index} className='border-border/60'>
					{_.times(6, (cellIndex) => (
						<TableCell key={cellIndex} className='py-3'>
							<Skeleton className='h-6 w-full bg-muted/40' />
						</TableCell>
					))}
				</TableRow>
			))}
		</>
	)
}
